import { useTranslation } from 'react-i18next';
import { Menu, Button, Box } from '@chakra-ui/react';
import { LANGUAGES } from '../../i18n/config';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: LANGUAGES.JA_HIRAGANA, label: 'ひらがな' },
    { code: LANGUAGES.JA_JP, label: '漢字' },
    { code: LANGUAGES.EN, label: 'English' },
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem('language', languageCode);
  };

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0];

  return (
    <Menu.Root positioning={{ placement: 'bottom-end' }}>
      <Menu.Trigger asChild>
        <Button
          w={{ base: 16, md: 20 }}
          cursor="pointer"
          borderRadius="lg"
          border="2px solid"
          borderColor="borders.default"
          bg="white"
          px={{ base: 2, md: 4 }}
          py={2}
          textAlign="center"
          fontSize={{ base: 'xs', md: 'sm' }}
          color="text.primary"
          boxShadow="md"
          transition="all 0.2s"
        >
          {currentLanguage.label}
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content
          w={30}
          borderRadius="lg"
          border="2px solid"
          borderColor="borders.emphasized"
          bg="white"
          boxShadow="lg"
          zIndex="dropdown"
        >
          {languages.map((lang) => (
            <Menu.Item key={lang.code} value={lang.code} asChild>
              <Box
                as="button"
                onClick={() => handleLanguageChange(lang.code)}
                w="full"
                textAlign="left"
                border="none"
                bg={i18n.language === lang.code ? 'blue.50' : 'transparent'}
                cursor="pointer"
                px={4}
                py={2}
                fontSize="sm"
                color="text.primary"
                fontWeight={i18n.language === lang.code ? 'semibold' : 'normal'}
                transition="all 0.2s"
                _hover={{
                  bg: 'blue.50',
                  color: 'primary',
                }}
              >
                {lang.label}
              </Box>
            </Menu.Item>
          ))}
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
};
